import removeRowsFromListViewStore from 'owa-mail-actions/lib/triage/removeRowsFromListViewStore';
import removeSingleItemFromConversation from '../mutators/removeSingleItemFromConversationMutator';
import getAllTableViewsContainingItems from '../utils/getAllTableViewsContainingItems';
import { TableQueryType, TableView } from 'owa-mail-list-store';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import tombstoneOperations, { TombstoneReasonType } from 'owa-mail-list-tombstone';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import deleteItemsStoreUpdate, {
    ItemContext,
} from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { createLazyOrchestrator } from 'owa-bundling';

export default createLazyOrchestrator(
    deleteItemsStoreUpdate,
    'clone_deleteItemsStoreUpdate',
    actionMessage => {
        const firstItemContext = actionMessage.itemContexts[0];
        const tableViews = getAllTableViewsContainingItems(
            firstItemContext && firstItemContext.mailboxInfo,
            actionMessage.parentFolderId,
            true /* shouldIncludeSearchTable */
        );

        for (const tableView of tableViews) {
            if (tableView.tableQuery.listViewType == ReactListViewType.Message) {
                removeItemsInMessageTable(actionMessage.itemContexts, tableView);
            } else if (tableView.tableQuery.listViewType == ReactListViewType.Conversation) {
                removeItemsInConversationTable(actionMessage.itemContexts, tableView);
            }
        }
    }
);

function removeItemsInMessageTable(itemContexts: ItemContext[], tableView: TableView) {
    const rowIds: string[] = itemContexts.map(itemContext => {
        return itemContext.itemId;
    });
    const rowKeys = getRowKeysFromRowIds(rowIds, tableView);

    // Filter to items that exist in this particular table
    const filteredRowKeys = rowKeys.filter(rowKey => tableView.rowKeys.indexOf(rowKey) >= 0);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }

    removeRowsFromListViewStore(filteredRowKeys, tableView);

    // Add deleted instanceKeys to tombstones so they don't pop back in
    addRowKeysToTombstone(tableView, rowKeys);
}

function removeItemsInConversationTable(itemContexts: ItemContext[], tableView: TableView) {
    for (const itemContext of itemContexts) {
        const conversationRowKeys = getRowKeysFromRowIds([itemContext.conversationId], tableView);
        for (const conversationRowKey of conversationRowKeys) {
            const tableConversationRelation = getTableConversationRelation(
                conversationRowKey,
                tableView.id
            );
            if (!tableConversationRelation) {
                // This item was not found in the current table, noop
                continue;
            }

            if (
                tableConversationRelation.itemIds.length == 1 &&
                tableConversationRelation.itemIds[0] == itemContext.itemId
            ) {
                // Removing the last item in the conversation, we need to remove the entire conversation row
                removeRowsFromListViewStore([conversationRowKey], tableView);

                // Add deleted instanceKeys to tombstones so they don't pop back in
                addRowKeysToTombstone(tableView, [conversationRowKey]);
            } else {
                removeSingleItemFromConversation(itemContext, tableView.id);
            }
        }
    }
}

function addRowKeysToTombstone(tableView: TableView, rowKeys: string[]) {
    // Add deleted instanceKeys to tombstones so they don't pop back in
    // Only need to do this for mail folder and group queries which supports notifications and pin(folderOnly)/delete actions
    if (
        tableView.tableQuery.type === TableQueryType.Folder ||
        tableView.tableQuery.type === TableQueryType.Group
    ) {
        tombstoneOperations.add(rowKeys, tableView.serverFolderId, TombstoneReasonType.RowRemove);
    }
}
